import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center py-2 position-fixed bottom-0 w-100">
      <p className="mb-0">&copy; 2024 | Bestower Foundation</p>
    </footer>
  );
};

export default Footer;
